export const BRAND = {
    name: "Synara Alvarenga",
    tagline: "Personal Chef",
    logo: "/assets/synara/logo.png",
    video: "/assets/synara/hero-video.mp4",
    chefPhoto: "/assets/synara/chef-photo.jpeg",
    whatsapp: "351924949524",
    whatsappDisplay: "+351 924 949 524",
    whatsappUrl: "https://wa.me/351924949524",
    instagram: "@synarapersonalchef",
    instagramUrl: "https://www.instagram.com/synarapersonalchef",
    email: "synarapersonalchef@gmail.com",
    images: {
        hero: "https://static.prod-images.emergentagent.com/jobs/ee98e198-cab0-4971-ab1a-895c6e25e49a/images/aff6097ed4a3b0a10157cf0f9d69e31ea1e66bfc0cb244592189ac4469d5e97b.png",
        gourmet: "https://static.prod-images.emergentagent.com/jobs/ee98e198-cab0-4971-ab1a-895c6e25e49a/images/30fc5f6caf3ece00454534d6e173b890955079cdd799468e09c3e0ec6492ae74.png",
        plating1: "https://images.unsplash.com/photo-1663530761401-15eefb544889?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
        plating2: "https://images.unsplash.com/photo-1676471926534-d5c9771909fa?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
        family: "https://images.unsplash.com/photo-1606788075819-9574a6edfab3?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
        couple: "https://images.unsplash.com/photo-1644446770253-5c6b45c38ba8?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
        healthy: "https://images.pexels.com/photos/5395180/pexels-photo-5395180.jpeg?auto=compress&cs=tinysrgb&w=1400",
        corporate: "https://images.unsplash.com/flagged/photo-1564697259787-6fc88465d327?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
        event: "https://images.unsplash.com/photo-1595037935521-15ce2282a03e?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
        mealprep: "https://images.unsplash.com/photo-1547592180-85f173990554?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
    },
};

export const buildWhatsAppUrl = (message) => {
    const phone = BRAND.whatsapp.replace(/[^0-9]/g, "");
    const text = encodeURIComponent(message || "");
    return `https://wa.me/${phone}?text=${text}`;
};
